export const InfoService = {
  appName: "DSC Node",
  appVersion: "1.0.0",
  appDescription: "DSC Node Management Application",
  developer: "Your Name or Company",
  contactEmail: "",
  website: "https://hdtsecure.com/",
  supportEmail: "",
  license: "MIT",
  repository: "",
  loginLink:"https://app.hdtsecure.com/?cat=",
  bookingLink: "https://book.hdtsecure.com",
  whatsappLink: "https://api.whatsapp.com/send?phone=919553896536",
  lastUpdated: "2024-06-01",
  mobile_no_1: "+91 9553896536",
  site_email: "sds@hdtsolution.com",
  social_media: {
    youtube: "https://youtube.com/@hdtsolutionsllp-o3n?si=i2s-EVxLrwncbikS ",

    facebook:
      "https://m.me/hdt.solutions.2025?hash=AbbkB8AEvnlhC-Fx&source=qr_link_share",
    twitter: "https://x.com/hdtsolutions25?t=gGWNzn-k9Gap9hOf-fJBNA&s=08",

    linkedin: "https://www.linkedin.com/company/hdt-solutions-llp/",
    instagram:
      "https://www.instagram.com/hdtsdsllp/?utm_source=qr&igsh=MTJjZXEzZGxua3oyNw%3D%3D#",
    whatsapp: "'https://wa.me/+91 9553896536",
  },
};
